<!-- 菜肴估重参考图页面 -->
<template>
  <div class="container">
    <div class="form">
      <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
        <el-row>
          <el-col :span="7">
            <el-form-item label="菜肴名称" prop="dishName">
              <el-input v-model="form.dishName" clearable placeholder="请输入菜肴名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="食材名称" prop="ingredientName">
              <el-input v-model="form.ingredientName" clearable placeholder="请输入食材名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="饮食类型" prop="dietType">
              <el-select v-model="form.dietType" clearable placeholder="请选择">
                <template v-for="item in dietTypeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey"/>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="用餐时段" prop="mealPeriod">
              <el-select v-model="form.mealPeriod" clearable placeholder="请选择">
                <template v-for="item in mealTimeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey"/>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="中医证型" prop="tcmSyndromeType">
              <el-select v-model="form.tcmSyndromeType" clearable placeholder="请选择">
                <template v-for="item in syndromeTypeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey"/>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="菜肴分类" prop="dishCategory">
              <el-select v-model="form.dishCategory" clearable placeholder="请选择">
                <template v-for="item in foodTypeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey"/>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="参考图状态" prop="imageStatus">
              <el-select v-model="form.imageStatus" clearable placeholder="请选择">
                <template v-for="item in picStatusList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey"/>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="17" style="text-align: right;">
            <el-form-item>
              <el-button type="primary" @click="fetchTableList">查询</el-button>
              <el-button @click="reSet">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="list">
      <div class="add">
        <el-button type="primary" @click="add" size="small" >通用类型</el-button>
      </div>
      <el-table :data="table" style="width: 100%">
        <el-table-column
            prop="serialNumber"
            align="center"
            label="序号"/>
        <el-table-column
            prop="dishName"
            align="center"
            label="菜肴组合名称"/>
        <el-table-column
            prop="dietType"
            align="center"
            label="饮食类型">
          <template #default="{ row }" >
            <span>{{ dietTypeName(row.dietType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="ingredientName"
            align="center"
            label="食材"/>
        <el-table-column
            prop="mealPeriod"
            align="center"
            label="用餐时段">
          <template #default="{ row }">
            <span>{{ mealPeriodName(row.mealPeriod) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="tcmSyndromeType"
            align="center"
            label="中医证型">
          <template #default="{ row }" >
            <span>{{ tcmSyndromeTypeName(row.tcmSyndromeType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="isCountEnergy"
            align="center"
            label="是否计入能量">
          <template #default="{ row }" >
            <span>{{ CAL_ANGE_MAP[row.isCountEnergy] ?? "" }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="dishCategory"
            align="center"
            label="菜肴分类">
          <template #default="{ row }" >
            <span>{{ dishCategoryName(row.dishCategory) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="imageId"
            align="center"
            label="参考图状态">
          <template #default="{ row }" >
            <span :class="imageStatusName(row).className" >{{ imageStatusName(row).dictValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="菜肴估重参考图">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="editClick(row)" >编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :page-sizes="[10, 20, 50, 100]"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>

    <ListGeneralType v-model="generalType.show" />

    <ReferencePicture v-model="referencePicture.show"
                      :id="referencePicture.id"
                      :dishName="referencePicture.dishName"
                      :imageId="referencePicture.imageId"
                      @updateList="getList" />

  </div>
</template>

<script>
import {get} from "@/api/http";
import ListGeneralType from "./components/ListGeneralType";
import ReferencePicture from "./components/ReferencePicture";
import { CAL_ANGE_MAP } from "@/components/DietaryNutrition/RecipeKnowledgeBase/index.data.js";

export default {
  name: "RecipePictureManage",
  components: {
    ListGeneralType,
    ReferencePicture,
  },
  data() {
    return {
      CAL_ANGE_MAP,
      form: {
        pageNum: 1,
        pageSize: 10,
        dishName: "",
        ingredientName: "",
        dietType: "",
        mealPeriod: "",
        tcmSyndromeType: "",
        dishCategory: "",
        imageStatus: "",
      },
      table: [],
      total: 0,
      dietTypeList: [], // 饮食类型列表
      mealTimeList: [], // 用餐时段列表
      syndromeTypeList: [], // 中医证型列表
      foodTypeList: [], // 菜肴分类列表
      picStatusList: [
        {
          dictKey: '1',
          dictValue: '已设置',
          className: "",
        },
        {
          dictKey: '0',
          dictValue: '未设置',
          className: "textColor",
        }
      ], // 参考图列表
      // 通用类型操作
      generalType: {
        show: false,
      },
      referencePicture: {
        show: false,
        id: "",
        dishName: "",
        imageId: "",
      }
    }
  },
  computed: {
    dietTypeName() {
      return function (e) {
        let str = "",
            arr = e.split(","),
            arr_ = (this.dietTypeList || []).filter(item => arr.includes(item.dictKey));
        if (arr_ && arr_.length > 0) {
          str = arr_.map(item => item.dictValue).join(",");
        }
        return str;
      }
    },
    mealPeriodName() {
      return function (e) {
        let str = "",
            arr = e.split(","),
            arr_ = (this.mealTimeList || []).filter(item => arr.includes(item.dictKey));
        if (arr_ && arr_.length > 0) {
          str = arr_.map(item => item.dictValue).join(",");
        }
        return str;
      }
    },
    tcmSyndromeTypeName() {
      return function (e) {
        let str = "",
            arr = e.split(","),
            arr_ = (this.syndromeTypeList || []).filter(item => arr.includes(item.dictKey));
        if (arr_ && arr_.length > 0) {
          str = arr_.map(item => item.dictValue).join(",");
        }
        return str;
      }
    },
    dishCategoryName() {
      return function (e) {
        let str = "",
            arr = e.split(","),
            arr_ = (this.foodTypeList || []).filter(item => arr.includes(item.dictKey));
        if (arr_ && arr_.length > 0) {
          str = arr_.map(item => item.dictValue).join(",");
        }
        return str;
      }
    },
    imageStatusName() {
      return function (e) {
        let obj = {};
        if (e && e.imageId) {
          obj = this.picStatusList[0];
        }else {
          obj = this.picStatusList[1];
        }
        return obj;
      }
    },
  },
  created() {
    this.fetchDietTypeList();
    this.fetchMealTimeList();
    this.fetchSyndromeTypeList();
    this.fetchFoodTypeList();
    this.getList();
  },
  methods: {
    editClick(e) {
      this.referencePicture.id = e.id;
      this.referencePicture.dishName = e.dishName;
      this.referencePicture.imageId = e.imageId;
      this.referencePicture.show = true;
    },
    add() {
      this.generalType.show = true;
    },
    async getList() {
      try {
        const res = await this.$get("dish/list", this.form);
        if (!res) return;
        const { data } = res;
        this.table = data.list;
        this.total = data.total;
      }catch (e) {
        console.error(`菜肴估重参考图列表查询失败: ${e}`);
      }
    },
    fetchTableList() {
      this.form.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(e) {
      this.form.pageNum = e;
      this.getList();
    },
    handleSizeChange(e) {
      this.form.pageSize = e;
      this.getList();
    },
    // 重置查询状态
    reSet() {
      this.form.pageNum = 1;
      this.form.pageSize = 10;
      this.$refs.formRef.resetFields();
      this.getList();
    },
    // 查询饮食类型
    async fetchDietTypeList() {
      try {
        const result = await get("dictionary/type/diet_food_consistency");
        const {data = []} = result || {};
        this.dietTypeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询用餐时段
    async fetchMealTimeList() {
      try {
        const result = await get("dictionary/type/diet_meal_time");
        const {data = []} = result || {};
        this.mealTimeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询中医证型
    async fetchSyndromeTypeList() {
      try {
        const result = await get("dictionary/type/diet_syndrome_type");
        const {data = []} = result || {};
        this.syndromeTypeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询菜肴分类
    async fetchFoodTypeList() {
      try {
        const result = await get("dictionary/type/diet_food_type");
        const {data = []} = result || {};
        this.foodTypeList = data;
      } catch (error) {
        console.log(error);
      }
    },
  }
}

</script>
<style scoped lang="scss">
.container {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;

  .list {
    flex: 1;

    .add-button-class {
      width: 100px;
    }
  }
}
.textColor{
  color: #3FBE19;
}
</style>
